import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import 'react-toggle/style.css' // for ES6 modules
import Toggle from 'react-toggle'
import axios from 'axios'
import Constant from '../../Constant'
import CustomFooter from '../../common/TableBottom'
import ActivitiesController from '../../common/activitiesController/ActivitiesController'

class DiwaniyaMasterList extends React.Component {
  state = {
    diwaniya_data: [],

    isloading: false,
    isEditing: false,
    selectedId: null,
    order: '',

    keyword: '',
    limit: 10,
    pageNumber: 0,
    disabled: false,
  }

  debounceTimeout = null

  handleStatusChange = (sid, status) => {
    if (sid) {
      let data = {
        id: sid,
        is_active: status,
      }

      axios
        .put(Constant.getAPI() + `/diwaniya/toggle-update`, data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then(() => {
          this.loadData()
          Swal.fire('Update Status!', 'Status has been updated.', 'success')
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }
  }

  deleteDiwaniya = (id) => {
    axios
      .delete(Constant.getAPI() + `/diwaniya/delete-diwaniya/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then(() => {
        Swal.fire({
          title: 'Deleted Successfully!',
          icon: 'success',
          text: '',
          type: 'success',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ok',
        })
        this.loadData()
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  componentDidMount() {
    this.loadData()
  }

  loadData = async () => {
    this.setState({ isloading: true })

    await axios
      .get(Constant.getAPI() + `/diwaniya/diwaniya-list`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
        params: {
          keyword: this.state.keyword,
          limit: this.state.limit,
          pageNumber: this.state.pageNumber,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({ isloading: false })
          this.setState({
            diwaniya_data: res.data.data,
          })
        }
      })
      .catch((err) => {
        this.setState({ isloading: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  onSearch = (event) => {
    this.setState(
      {
        keyword: event.target.value,
        pageNumber: 0,
      },
      () => {
        if (this.debounceTimeout) clearTimeout(this.debounceTimeout)

        this.debounceTimeout = setTimeout(() => {
          this.loadData()
        }, 500)
      }
    )
  }

  clearSearch = () => {
    this.setState(
      {
        keyword: '',
        pageNumber: 0,
      },
      () => {
        this.loadData()
      }
    )
  }

  onEdit = (selectedId, order) => {
    this.setState({
      isEditing: true,
      selectedId,
      order,
    })
  }

  onChangeSort = (selectedId) => {
    var data = {
      diwaniya_id: selectedId,
      order: parseInt(this.state.order),
    }

    this.setState({ isEditing: false, selectedId: null })

    axios
      .put(Constant.getAPI() + '/diwaniya/update-diwaniya-priority', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then(() => {
        this.loadData()
      })
      .catch(() => {})
  }

  onInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }

  render() {
    const customSearchRender = (searchText, handleSearch, hideSearch) => {
      return (
        <div className="container">
          <div className="d-flex justify-content-around">
            <i className="f-16 icofont icofont-search m-t-10 m-r-10"></i>
            <input
              type="search"
              className="form-control custom-input-search"
              placeholder="Search Order number"
              value={this.state.keyword}
              name="keyword"
              onChange={this.onSearch}
            />

            <span
              className="pointer m-t-5"
              style={{ cursor: 'pointer' }}
              onClick={() => {
                this.clearSearch(hideSearch)
              }}
            >
              <i className="f-24 icofont icofont-close m-l-10"></i>
            </span>
          </div>
        </div>
      )
    }

    const columns = [
      {
        name: 'item_img',
        label: 'Image',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (cruise_thumb_img) => {
            return (
              <div>
                {cruise_thumb_img !== null ? (
                  <div>
                    {cruise_thumb_img?.indexOf('.mp4') !== -1 ? (
                      <video
                        width="250"
                        controls
                      >
                        <source
                          src={
                            cruise_thumb_img !== undefined && cruise_thumb_img !== null && cruise_thumb_img !== {}
                              ? Constant.getImage() + cruise_thumb_img
                              : './assets/images/icon.png'
                          }
                          type="video/mp4"
                        />
                      </video>
                    ) : (
                      <img
                        src={
                          cruise_thumb_img !== undefined && cruise_thumb_img !== null && cruise_thumb_img !== {}
                            ? Constant.getImage() + cruise_thumb_img
                            : './assets/images/icon.png'
                        }
                        className="img-fluid img-40"
                        alt="tbl"
                        onError={(event) => {
                          event.currentTarget.src = './assets/images/no_image.png'
                        }}
                      />
                    )}
                  </div>
                ) : (
                  <img
                    src={
                      cruise_thumb_img !== undefined && cruise_thumb_img !== null && cruise_thumb_img !== {}
                        ? Constant.getImage() + cruise_thumb_img
                        : './assets/images/icon.png'
                    }
                    className="img-fluid img-40"
                    alt="tbl"
                    onError={(event) => {
                      event.currentTarget.src = './assets/images/no_image.png'
                    }}
                  />
                )}
              </div>
            )
          },
        },
      },
      {
        name: 'item_name_en',
        label: `Name:English`,
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'item_name_ar',
        label: `Name:Arabic`,
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'item_desc_en',
        label: 'Description: English',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'item_desc_ar',
        label: 'Description: Arabic',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'order',
        label: 'Order',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (order, tableMeta) => {
            var id = tableMeta.rowData[tableMeta.rowData.length - 1] // Adjust index based on your data structure
            return (
              <div className="form-group">
                <div className="form-group">
                  <div className="input-group mb-3">
                    {this.state.isEditing ? (
                      this.state.selectedId === id ? (
                        <input
                          type="text"
                          name="order"
                          className="form-control px-1 form-control-sm"
                          style={{ width: '50px' }}
                          onChange={this.onInputChange}
                          value={this.state.order}
                        />
                      ) : (
                        <div
                          className="form-control"
                          style={{ width: '50px' }}
                        >
                          {order}
                        </div>
                      )
                    ) : (
                      <div
                        className="form-control"
                        style={{ width: '50px' }}
                      >
                        {order}
                      </div>
                    )}{' '}
                    <div className="input-group-append border">
                      {this.state.isEditing ? (
                        this.state.selectedId === id ? (
                          <span
                            className="input-group-text d-flex justify-content-center align-items-center   shadow-sm"
                            onClick={this.onChangeSort.bind(this, id)}
                          >
                            <i className="f-15 bg-white p-2 icofont icofont-ui-check"></i>
                          </span>
                        ) : (
                          <span
                            className="input-group-text d-flex justify-content-center align-items-center   shadow-sm"
                            onClick={this.onEdit.bind(this, id, order)}
                          >
                            <i className="f-15 bg-white p-2 icofont icofont-ui-edit text-custom"></i>
                          </span>
                        )
                      ) : (
                        <span
                          className="input-group-text d-flex justify-content-center align-items-center   shadow-sm"
                          onClick={this.onEdit.bind(this, id, order)}
                        >
                          <i className="f-15 bg-white p-2 icofont icofont-ui-edit text-custom"></i>
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )
          },
        },
      },
      {
        name: 'is_active',
        label: 'Status',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (is_active, tableMeta) => {
            const id = tableMeta.rowData[tableMeta.rowData.length - 1]
            return (
              <Toggle
                id={'status' + id}
                checked={is_active}
                onChange={this.handleStatusChange.bind(this, id, !is_active)}
              />
            )
          },
        },
      },
      {
        name: 'id',
        label: 'Actions',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (id) => {
            return (
              <div className="d-flex justify-content-end align-items-center">
                <Link
                  to={`/gallary-list/addons/${id}`}
                  className="m-r-15 text-muted"
                >
                  <i className="f-20 icofont icofont-image text-dark"></i>
                </Link>
                <Link
                  to={`/diwaniya/add/${id}`}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Edit"
                >
                  <i className="f-20 icofont icofont-ui-edit text-custom"></i>
                </Link>
                <span
                  onClick={this.deleteDiwaniya.bind(this, id)}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Delete"
                >
                  <i className="f-20 icofont icofont-delete-alt text-danger"></i>{' '}
                </span>
                <ActivitiesController refId={id}>Activities</ActivitiesController>
              </div>
            )
          },
        },
      },
    ]

    const options = {
      filterType: true,
      viewColumns: false,
      print: false,
      download: false,
      customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage) => {
        return (
          <CustomFooter
            changePage={changePage}
            changeRowsPerPage={changeRowsPerPage}
            disabled={this.state.disabled}
            count={this.state.limit}
            pageNumber={this.state.pageNumber}
          />
        )
      },
      onChangePage: (currentPage) => {
        this.setState(
          {
            pageNumber: currentPage,
          },
          () => {
            this.loadData()
          }
        )
      },
      onChangeRowsPerPage: (numberOfRows) => {
        this.setState(
          {
            limit: numberOfRows,
          },
          () => {
            this.loadData()
          }
        )
      },
      customSearchRender: customSearchRender,
      onSearchClose: () => {
        this.clearSearch()
      },

      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isloading ? 'Loading data..!' : 'Sorry, No Products Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }

    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Addons List</h4>
                    </div>
                  </div>
                  <Link
                    to={`/diwaniya/add`}
                    className="btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger"
                    data-modal="modal-13"
                  >
                    {' '}
                    <i className="icofont icofont-plus m-r-5"></i>
                    Addons Add
                  </Link>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">{this.props.match.params.boatType} Addons List</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      <div className="dt-responsive table-responsive">
                        <MUIDataTable
                          title="Addons List"
                          className="table-responsive"
                          data={this.state.diwaniya_data}
                          columns={columns}
                          options={options}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default DiwaniyaMasterList
